module.exports = __webpack_public_path__ + "ac92ca72dd2c0ad4d5bc47b49c678241.pdf";